// extracted by mini-css-extract-plugin
export default {"fullWidth":"nn-z","image":"on-z","lazyLoadPicture":"pn-z","lazyLoadSpinner":"qn-z","lazyLoadSpin":"rn-z","lazyLoadImage":"sn-z","hasStyledAspectRatio":"tn-z"};